import React, { FC } from 'react'
import './category.css'

const Category:FC = () => {
  return (
    <div className='title__container'>
        <div className="title__wrapper">
            <img src="/img/widgets/categories.png" alt=''/>
        </div>
    </div>
  )
}

export default Category